import useResources from "./use-resources";
import { findAndUpdate } from "../utils/index.jsx";

const ROOT_PATH = "profiles";

export default function useProfileBailleurs(options = {}) {
  const { withById = false } = options;

  const {
    resources: profileBailleurs,
    resourcesById: profileBailleursById,
    error,
    isLoading,
    create,
    update,
    del,
    mutate,
    axios,
  } = useResources(ROOT_PATH, {}, { withById });

  async function shareProfileBailleur(profileNomId, mail, droits = "RW") {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.post(
          `${ROOT_PATH}/${profileNomId}/share`,
          {
            mail,
            droits,
          },
        );
        newResource = response.data;
        return findAndUpdate(
          current,
          (resource) => resource.id === profileNomId,
          newResource,
        );
      },
      { revalidate: false },
    );
    return newResource;
  }

  async function updateSharedProfileDroits(profileNomId, mail, droits) {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.put(`${ROOT_PATH}/${profileNomId}/share`, {
          mail,
          droits,
        });
        newResource = response.data;
        return findAndUpdate(
          current,
          (resource) => resource.id === profileNomId,
          newResource,
        );
      },
      { revalidate: false },
    );
    return newResource;
  }

  async function deleteSharedProfileBailleur(profileNomId, mail) {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.post(
          `${ROOT_PATH}/${profileNomId}/share/delete`,
          { mail },
        );
        newResource = response.data;
        return findAndUpdate(
          current,
          (resource) => resource.id === profileNomId,
          newResource,
        );
      },
      { revalidate: false },
    );
    return newResource;
  }

  async function profileBailleurToQlower(profileNomId) {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.put(
          `${ROOT_PATH}/${profileNomId}/send-to-compta`,
        );
        newResource = response.data;
        return findAndUpdate(
          current,
          (resource) => resource.id === profileNomId,
          newResource,
        );
      },
      { revalidate: false },
    );
    return newResource;
  }

  return {
    profileBailleurs,
    profileBailleursById,
    error,
    isLoading,
    addProfileBailleur: create,
    updateProfileBailleur: update,
    deleteProfileBailleur: del,
    shareProfileBailleur,
    updateSharedProfileDroits,
    deleteSharedProfileBailleur,
    profileBailleurToQlower,
  };
}
